export default {
  "content": "<rect width=\"40\" height=\"40\" y=\".13\" fill=\"#1371C8\" rx=\"4\"/><rect width=\"40\" height=\"40\" y=\".13\" fill=\"#000\" fill-opacity=\".2\" rx=\"4\"/><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M20 5.847c-7.429 0-13.489 5.57-13.489 12.399 0 3.677 1.763 7.13 4.822 9.501v6.665l7.327-3.828c.48.045.918.06 1.34.06 7.429 0 13.489-5.569 13.489-12.398 0-6.83-6.06-12.399-13.489-12.399zm7.385 16.076a.89.89 0 01-.874.9.935.935 0 01-.51-.164l-1.995-1.486v.465c0 .66-.51 1.186-1.15 1.186H14.42c-.641 0-1.15-.54-1.15-1.186v-5.854c0-.66.509-1.186 1.15-1.186h8.434c.641 0 1.15.54 1.15 1.186v.465l1.997-1.486a.865.865 0 01.51-.165c.48 0 .873.405.873.9v6.425z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "40",
    "height": "41",
    "fill": "none",
    "viewBox": "0 0 40 41"
  }
};